// Traducciones en español para la sección "Quiénes somos"
const whoweare = {
  whoweare: "¿QUIENES SOMOS?",
  whoweareText0:
    "¿No has oído hablar de Zaquiel? Es normal. A fin de cuentas es la primera vez que nos fijamos en él.",
  whoweareText1:
    "Además, él mismo no tiene aún muy claro quién es, así que… sigámoslo, a ver que le trae a «El Valle del Silencio», en el Bierzo.",
  whoweareText2:
    "Este cómic forma parte del proyecto 'Investigación en base al cómic digital para la divulgación del patrimonio cultural de Castilla y León' (ICDIDIPACU) de la UEMC, perteneciente a la 'Convocatoria de ayudas destinadas a la conservación y promoción del patrimonio arquitectónico y culturas de Castilla y León', financiadas por la Fundación de Castilla y León.",
  whoweareText3: "Depósito legal: DL VA 137-2024",
  whoweareTitle: "¡Presentando una nueva saga de aventuras!",
  whoweareAuthors: "Autores"
}; 

export default whoweare; 